export const VUEX_REPORTING_SUBMIT = 'VUEX_REPORTING_SUBMIT'
export const VUEX_REPORTING_REPORT_ADD_TO_QUEUE = 'VUEX_REPORTING_REPORT_ADD_TO_QUEUE'
export const VUEX_REPORTING_REPORT_STATUS_UPDATE = 'VUEX_REPORTING_REPORT_STATUS_UPDATE'
export const VUEX_REPORTING_REPORT_POP = 'VUEX_REPORTING_REPORT_POP'
